import React from "react";
import { FixedColumn } from "../common/Flex";
import styled from "styled-components";

const ServingSizeInput = styled.input`
 width:85px;
 height:50px;
 text-decoration:underline;
 border:2px solid var(--jargon-primary);
 text-align:center;
 color:var(--jargon-secondary);
 background-color:var(--control-background);
 margin-top:15px;
    &:focus {
    outline:none;
        border:2px solid var(--jargon-secondary);
    }
    &::placeholder {
        color: #bcbbb8;
    }
`;

interface ServingSizeProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>  {
    value: string;
    onChange: (val:string) => void;
}

const ServingSize : React.FC<ServingSizeProps> = ({value, onChange, ...rest}) => {
    return(
        <ServingSizeInput value={value} onChange={(e) => onChange(e.target.value)} />
    );
};

export default ServingSize;